export const isStandaloneApp = () => {
  if (typeof window === "undefined") return false;
  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    (window.navigator as Navigator & { standalone?: boolean }).standalone === true
  );
};

export const isIosStandaloneApp = () => {
  if (typeof window === "undefined" || !isStandaloneApp()) return false;
  const ua = window.navigator.userAgent || "";
  return /iPad|iPhone|iPod/.test(ua) || (window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1);
};

export const shouldUseManualStandaloneOauthRedirect = () => isStandaloneApp() && !isIosStandaloneApp();

export const beginStandaloneOauthRedirect = (url: string) => {
  if (typeof window === "undefined") return;
  window.location.assign(url);
};
